export default __webpack_public_path__ + "static/media/document.a565bff0.svg";